import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Landmark } from "lucide-react";
import { useT } from "@/lib/i18n";
import { useCurrency } from "@/lib/currency";

const ROWS = [
    ["bank_name", "book.bank.bankName"],
    ["account_name", "book.bank.accountName"],
    ["account_number", "book.bank.accountNumber"],
    ["routing_number", "book.bank.routing"],
    ["swift_bic", "book.bank.swift"],
];

export default function BankTransferDialog({ booking, details = {}, open, onClose }) {
    const { t } = useT();
    const { format: formatMoney } = useCurrency();
    const ref = (booking?.id || "").slice(0, 8).toUpperCase();

    return (
        <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
            <DialogContent className="max-w-md" data-testid="bank-transfer-dialog">
                <DialogHeader>
                    <div className="w-12 h-12 rounded-full bg-forest/10 flex items-center justify-center mb-2">
                        <Landmark className="text-forest" size={22} />
                    </div>
                    <DialogTitle className="font-serif text-3xl">{t("book.bank.title")}</DialogTitle>
                    <DialogDescription>{t("book.bank.subtitle", formatMoney(booking?.total_price || 0))}</DialogDescription>
                </DialogHeader>

                <div className="border border-espresso/15 divide-y divide-espresso/10" data-testid="bank-transfer-details">
                    <Row label={t("book.bank.amount")} value={formatMoney(booking?.total_price || 0)} mono />
                    <Row label={t("book.bank.reference")} value={ref} mono testid="bank-reference" />
                    {ROWS.map(([key, labelKey]) => (
                        details[key] ? <Row key={key} label={t(labelKey)} value={details[key]} /> : null
                    ))}
                </div>

                {details.instructions && (
                    <p className="text-xs text-muted2 leading-relaxed mt-2">{details.instructions}</p>
                )}

                <button
                    onClick={onClose}
                    data-testid="bank-transfer-done"
                    className="w-full mt-2 px-6 py-4 bg-forest text-bone hover:bg-forestDark text-xs uppercase tracking-widest2 font-semibold"
                >
                    {t("book.bank.done")}
                </button>
            </DialogContent>
        </Dialog>
    );
}

function Row({ label, value, mono, testid }) {
    return (
        <div className="flex justify-between items-center gap-4 px-4 py-3">
            <span className="text-[11px] uppercase tracking-widest2 text-espresso/70">{label}</span>
            <span className={`text-sm text-ink text-right ${mono ? "font-mono" : ""}`} data-testid={testid}>{value}</span>
        </div>
    );
}
